// @TODO: maybe hide messages after a decision has been made (except for admin view)? or maybe after x months? don't think the full history is necessary...
/*
 * Ryan O'Dowd
 * 2023-01-21
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useEffect,
  useState,
} from 'react';
import {
  TouchableOpacity,
  View,
} from 'react-native';
import {
  fetchI18n,
  fetchI18nNotes,
  fetchLocales,
  saveNewTranslations,
} from '@utils/store/actions';
// @TODO: import Auth from '@containers/Auth'; // @TODO: should be able to handle this via router instead of redirecting within this component?
import Button from '@components/common/Button';
import Dialog from '@components/common/Dialog';
import IconButton from '@components/common/IconButton';
import Select from '@components/common/Select';
import Text from '@components/common/Text';
import TextInput from '@components/common/TextInput';
import Translation from './Translation';
import WebPageStub from '@website/containers/WebPageStub';
import WebsiteSection from '@website/components/WebsiteSection';
import fb from '@utils/firebase';
import getStyles from './styles';
import hooks from '@hooks';
import {
  useParams,
} from 'react-router';

const JUST_IN_CASE_ARGS = Array(10).fill('<>');
const GENERAL_I18N_IDS = [964, 965, 966]; // @TODO: dynamic

const I18n = () => {
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);
  const navigation = hooks.useNavigation();

  const {
    localeId,
  } = useParams(); // @TODO: remove use of useParams everywhere

  const [_newTranslationText, setNewTranslationText] = useState('');

  const locales = hooks.useTypedSelector((state) => state.locales);
  const reduxI18nOther = hooks.useTypedSelector((state) => state.i18n[localeId]);
  const locale = locales[localeId];

  const newTranslationsReturnValue = hooks.useTypedSelector((state) => state.newTranslationsReturnValue);

  const i18nEn = hooks.useI18n(1);
  const i18nOther = hooks.useI18n(locale?.id);

  const [_isAddTranslationDialogOpen, setIsAddTranslationDialogOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchLocales());
    dispatch(fetchI18n(1, true));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchI18n(localeId, true));
  }, [dispatch, localeId]);

  const oakUser = hooks.useTypedSelector((state) => state.oakUser);
  const isAdmin = hooks.useIsAdmin();

  useEffect(() => {// @TODO: handle this better when auth is done via outlet in react router
    // @TODO: currently need to fetch all to get own votes without having to open notes: if (_isNotesOpen) {
    // @TODO: }
    const authUnsubscribe = fb.onAuthStateChanged(fb.auth, async (authUser) => {
      if (authUser && locale?.id) {
        dispatch(fetchI18nNotes(locale.id));
      }

      return () => authUnsubscribe();
    });
  }, [dispatch, oakUser, locale?.id]);

  const notes = hooks.useTypedSelector((state) => state.i18nNotes);

  const [_searchText, setSearchText] = useState('');
  const [_unreviewedCollapsed, setUnreviewedCollapsed] = useState(true);

  if (!locale) {
    // @TODO: redirect to login or home (or maybe just redirect to /i18n/1)
    return <Text>no locale</Text>;// @TODO: i18n
  }

  const _arrayToEnglishList = (arr) => {
    return arr.map((l) => l.language_name).join(', ').replace(/,(?!.*,)/gmi, Object.values(locales).length < 3 ? ' and' : ', and');
  };

  const searchTerms = _searchText.toLocaleLowerCase().split(' ');
  const filteredI18ns = (reduxI18nOther?.i18n || []).filter((otherI18n) => {
    if (otherI18n.disabled_at) {
      return false;
    }

    if (!searchTerms.length) {
      return true;
    }

    // add args just in case it's a function
    const enValue = i18nEn(otherI18n.key, ...JUST_IN_CASE_ARGS).toLocaleLowerCase();
    const otherValue = i18nOther(otherI18n.key, ...JUST_IN_CASE_ARGS).toLocaleLowerCase();

    return searchTerms.every((searchTerm) => {
      if (otherI18n.key.toLocaleLowerCase().includes(searchTerm)) {
        return true;
      }

      if (enValue.includes(searchTerm)) {
        return true;
      }

      if (otherValue.includes(searchTerm)) {
        return true;
      }

      return false;
    });
  }).map((otherI18n) => {
    let mostRecentVote = (notes[otherI18n.id] || []).filter((n) => n.user_id === oakUser?.id && n.upvoted !== null).pop()?.upvoted;
    if (mostRecentVote === undefined) {
      // can't do `|| -1` because `0` is a valid value
      mostRecentVote = -1;
    }

    return {
      ...otherI18n,
      mostRecentVote,
    };
  }).sort((a, b) => {
    if (GENERAL_I18N_IDS.includes(a.id)) {
      return -1;
    }
    if (GENERAL_I18N_IDS.includes(b.id)) {
      return 1;
    }

    // sort by general feedback, then no-vote, then downvoted, then upvoted, then updated_at
    if (a.mostRecentVote === b.mostRecentVote) {
      return (new Date(b.updated_at).getTime()) - (new Date(a.updated_at).getTime());
    }

    return a.mostRecentVote - b.mostRecentVote;
  });

  const isShowMoreVisible = !_searchText && _unreviewedCollapsed && filteredI18ns.filter((i) => i.mostRecentVote === -1).length > 5;

  return ( // @TODO: would be cool to have international flags in background or something
    <WebPageStub>
      <WebsiteSection
        isDarkBackground={true}
        title='Wrinkly translations'
      >
        <View style={styles.verseWrapper}>{/* @TODO: convert this to Passage component */}
          <Text style={styles.verseBody}>
            <Text style={styles.verseBody}>{'Then Jesus came to them and said, "All authority in heaven and on earth has been given to me. Therefore go and make disciples of '}</Text>
            <Text style={[styles.verseBody, styles.bold]}>all nations</Text>
            <Text style={styles.verseBody}>{', baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything I have commanded you. And surely I am with you always, to the very end of the age."'}</Text>
          </Text>
          <Text style={styles.reference}>Matthew 28:18-20, NIV</Text>
        </View>
        <Text style={styles.introText}>{`Thanks so much for your help to translate Wrinkly!  With help from translators like you, Wrinkly is available for users who speak ${_arrayToEnglishList(Object.values(locales))}!`}</Text>
        {!oakUser
          ? (
            <React.Fragment>
              <Text style={styles.introText}>To view translations and provide feedback, please sign in:</Text>
              <Button
                style={styles.signInButton}// @TODO: need this?
                theme={styles.colors.accent}
                // @TODO: onPress={() => setIsAuthOpen(true)}// @TODO: handle this better
              >
                Sign in
              </Button>
            </React.Fragment>
          )
          : (
            <View>
              <Text style={styles.introText}>{'If a translation is correct, please give it a "thumbs up".  If it is incorrect or you have a suggestion for a better translation, please click the "thumbs down" button.'}</Text>
              <Text style={styles.introText}>If you have any questions or comments in addition to the vote, they can be added by clicking the notes icon next to the thumbs up/down icons.</Text>
              <Text style={styles.introText}>Please be picky--any improvements to vocabulary, grammar, spelling, and colloquialisms are all welcome.  We and native users thank you for all improvements, both big and small!</Text>
            </View>
          )
        }
      </WebsiteSection>

      {!!oakUser &&
        <WebsiteSection
          isDarkBackground={false}
        >
          {/* @TODO: group by section (and toggle isDarkBackground) and put in accordion? */}
          <View style={styles.controlsWrapper}>
            <Select
              label={i18n('localeText')}
              options={Object.values(locales).map((l: any) => {
                return {
                  label: `${l.language_name_local} (${l.iso_639_3}: ${l.language_name})`,
                  value: l.id,
                };
              })}
              value={locale?.id}
              onChange={(value) => navigation.navigate(`/i18n/${value}`)}
            />
            <View style={[styles.searchBarWrapper, styles.fullWidth]}>{/* @TODO: abstract with help */}
              <TextInput
                value={_searchText}
                mode='outlined'
                onChangeText={(text) => setSearchText(text)}
                label='Search all text'
                right={// @TODO: not visible
                  <IconButton
                    icon='close'
                    iconColor={styles.colors.gray}
                    onPress={() => setSearchText('')}
                  />
                }
              />
            </View>
            {isAdmin &&
              <View style={styles.sortButtonWrapper}>
                <IconButton
                  icon='plus'
                  iconColor={styles.colors.gray}
                  onPress={() => setIsAddTranslationDialogOpen(true)}
                />
              </View>
            }
            {/* @TODO:
            <View style={styles.sortButtonWrapper}>
              <IconButton
                icon='sort'
                iconColor={styles.colors.gray}
                onPress={() => {
                  // @TODO: implement
                  // @TODO: sort by group/screen, updated_at, etc.
                }}
              />
            </View>
            <View>
              <IconButton
                icon='filter'
                iconColor={styles.colors.gray}
                onPress={() => {
                  // @TODO: implement
                  // @TODO: filters to hide completed translations
                }}
              />
            </View>
            */}
          </View>
          {/* @TODO: add general discussion board here */}
          {isShowMoreVisible
            ? (
              <React.Fragment>
                {filteredI18ns.slice(0, 5).map((i) => {
                  return (
                    <Translation
                      key={i.id}
                      i18nId={i.id}
                      i18nKey={i.key}
                      mostRecentVote={i.mostRecentVote}
                      englishValue={i18nEn(i.key, ...JUST_IN_CASE_ARGS)}
                      locale={locale}
                      localeValue={i.value}
                      searchTerms={searchTerms}
                      isGeneralFeedback={GENERAL_I18N_IDS.includes(i.id)}
                    />
                  );
                })}
                <TouchableOpacity
                  style={styles.showAllToggle}
                  onPress={() => {
                    setUnreviewedCollapsed(!_unreviewedCollapsed);
                  }}
                >
                  <Text>{`show all unreviewed (${filteredI18ns.filter((i) => i.mostRecentVote === -1).length})`}</Text>
                </TouchableOpacity>
                {filteredI18ns.filter((i) => i.mostRecentVote !== -1).map((i) => {
                  return (
                    <Translation
                      key={i.id}
                      i18nId={i.id}
                      i18nKey={i.key}
                      mostRecentVote={i.mostRecentVote}
                      englishValue={i18nEn(i.key, ...JUST_IN_CASE_ARGS)}
                      locale={locale}
                      localeValue={i.value}
                      searchTerms={searchTerms}
                      isGeneralFeedback={GENERAL_I18N_IDS.includes(i.id)}
                    />
                  );
                })}
              </React.Fragment>
            )
            : (
              filteredI18ns.map((i) => {
                return (
                  <Translation
                    key={i.id}
                    i18nId={i.id}
                    i18nKey={i.key}
                    mostRecentVote={i.mostRecentVote}
                    englishValue={i18nEn(i.key)}
                    locale={locale}
                    localeValue={i.value}
                    searchTerms={searchTerms}
                    isGeneralFeedback={GENERAL_I18N_IDS.includes(i.id)}
                  />
                );
              })
            )
          }
          {!filteredI18ns.length &&
            <Text style={styles.emptyScreenText}>
              {`No search results for "${_searchText}"`}
            </Text>
          }
        </WebsiteSection>
      }

      {_isAddTranslationDialogOpen &&
        <Dialog
          visible={true}
          onDismiss={() => setIsAddTranslationDialogOpen(false)}
        >
          <Dialog.Title>{i18n('addTranslation')}</Dialog.Title>
          <Dialog.Content>
            <Text>JSON in the format:</Text>
            <pre style={{maxWidth: 500, overflowX: 'scroll'}}>{/* @TODO: prettier...should be admin only though */}{/* @TODO: convert to Text and have prop for monospaced? or just styles? */}
              {`{
  "psalmText": {
    "1": "\\"I have hidden your word in my heart that I might not sin against you.\\"",
    "2": "\\"En mi corazón atesoro tus dichos para no pecar contra ti.\\"",
    "3": "\\"In meinem Herzen habe ich dein Wort verwahrt, auf daß ich nicht wider dich sündige.\\""
  },
  "psalmReference": {
    "1": "Psalm 119:11 NIV",
    "2": "Salmos 119:11 NVI",
    "3": "Psalm 119:11 ELB"
  }
}`}{/* @TODO: is that elb or hof? */}
            </pre>
            <TextInput
              style={styles.addTranslationTextInput}
              label='JSON'
              mode='outlined'
              multiline
              // @TODO: paper equivalent? minRows={7}
              // @TODO: paper equivalent? maxRows={14}
              // @TODO: required={true}
              value={_newTranslationText}
              onChangeText={(text) => setNewTranslationText(text)}
            />
            <Text>{newTranslationsReturnValue}</Text>
          </Dialog.Content>
          <Dialog.Actions>
            <Button
              mode='text'
              onPress={() => setIsAddTranslationDialogOpen(false)}
            >
              {i18n('cancel')}
            </Button>
            <Button
              mode='contained'
              onPress={() => {
                dispatch(saveNewTranslations(_newTranslationText));
              }}
            >
              {i18n('save')}
            </Button>
          </Dialog.Actions>
        </Dialog>
      }

    </WebPageStub>
  );
};

export default I18n;
